var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-item"},[_c('div',{class:['nav-link', _vm.isActive ? ("active " + _vm.active) : null],on:{"click":function($event){return _vm.tabs.onSelect(_vm.value)}}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }